import React, { useState } from "react";
import PropTypes from "prop-types";
import { useTheme } from "@mui/material/styles";
import "react-date-range/dist/styles.css"; // main css file
import "react-date-range/dist/theme/default.css"; // theme css file
import { DateRange } from "react-date-range";
import locale from "date-fns/locale/en-GB";
import { addDays, subDays } from "date-fns";
import useResponsive from "../../hooks/useResponsive";
import { InputCustomIcon } from "./input-ui";

import CalendarMonthIcon from "@mui/icons-material/CalendarMonth";
import { Box, Button, Divider, Stack, Typography } from "@mui/material";

interface RangeProps {
  onChange: (date: any) => void; // Callback function for date change event.
}
const inputSty = {
  color: "black",
  backgroundColor: "#f5f7f9",
  padding: "8px",
  fontSize: "14px",
  width: "35%",
  border: "none",
  fontFamily: '"Lexend", sans-serif',
};
const DateRangeInput = ({ onChange }: RangeProps) => {
  const theme = useTheme();
  const isMedium = useResponsive("down", "md", "xl");
  const [range, setRange] = useState([
    {
      startDate: new Date(),
      endDate: new Date(),
      key: "selection",
    },
  ]);

  const [view, setView] = useState(false);

  // Handle date range selection
  const handleSelect = (ranges: any) => {
    setRange([ranges.selection]);
    
  };

  const handleSelectedRange = () => {
    onChange({ startDate: range[0].startDate.toISOString(), endDate: range[0].endDate.toISOString() });
    setView(false);
  };

  return (
    <div>
      {view ? (
        <Box>
          <DateRange
            ranges={range} // Pass the current selected range
            onChange={handleSelect} // Update the selected range
            moveRangeOnFirstSelection={false}
            minDate={new Date()}
            locale={locale}
            direction={isMedium ? "vertical" : "horizontal"} // Responsive layout
            showDateDisplay={!isMedium} // Hide date display on mobile
            rangeColors={["#284CB1"]} // Customize range colors
            editableDateInputs={true} // Make date inputs editable
          />
          <Stack direction={"row"} sx={{ gap: 3 }} justifyContent={"center"}>
            <Button
              sx={{ fontWeight: 700, cursor: "pointer" }}
              color={"primary"}
              onClick={() => setView(false)}
            >
              Cancel
            </Button>
            <Button
              sx={{ fontWeight: 700 }}
              color={"primary"}
              onClick={handleSelectedRange}
            >
              Set
            </Button>
          </Stack>
        </Box>
      ) : (
        <Box
          onClick={() => setView(true)}
          sx={{
            cursor: "pointer",
            display: "flex",
            flexDirection: "row",
            justifyContent: "space-between",
            alignItems: "center",
            borderRadius: "4px",
            gap: 2,
            backgroundColor: "#f5f7f9",
            paddingY: 2,
            my: 2,
          }}
        >
          <input
            style={{ ...inputSty, textAlign: "center" }}
            placeholder="Start"
            defaultValue={range[0].startDate.toLocaleDateString()}
          />

          <Divider orientation="vertical" variant="middle" flexItem />
          <input
            style={{ ...inputSty, textAlign: "center" }}
            placeholder="End"
            defaultValue={range[0].endDate.toLocaleDateString()}
          />
          <span style={{ margin: "0 4px" }}>
            <CalendarMonthIcon sx={{ color: theme.palette.primary.main }} />
          </span>
        </Box>
      )}
    </div>
  );
};

export default DateRangeInput;
